var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopMenu'),_c('SearchBox'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('router-link',{attrs:{"to":"ChangeSeason"}},[_vm._v("跳转到季节页面")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }